<template>
  <b-modal id="business-new" size="lg" centered hide-header hide-footer>
    <div class="align-middle">
      <b-row>
        <b-col class="position-static mx-3">
          <h1 class="mb-4 mt-md-3">
            Business Registration
          </h1>
          <h6 class="color-blue mb-3">What Business are we Registering?</h6>
          <b-form class="row">
            <b-col md="8" class="mb-3">
              <maz-select v-model="business.status" placeholder="Business Status" clearable required :success="business.status !== null && business.status !== ''" :options="statuses"></maz-select>
            </b-col>
            <b-col md="8" class="mb-5">
              <maz-select v-model="business.type" placeholder="Business Type" clearable required :success="business.type !== null && business.type !== ''" :options="types"></maz-select>
            </b-col>

            <div v-if="business.type === 'SA Registered Company (Private Company – Pty Limited)' || business.type === 'SA Registered Closed Corporation (CC)'">
              <b-col md="12" class="mb-3">
                <b-form-group>
                  <template v-slot:label>
                    Are the Business Shareholders <strong>(of 5% or more)</strong>:
                  </template>
                  <b-form-radio name="shareholders" v-model="business.shareholders" value="Limited to individuals (natural persons)">
                    Limited to individuals (natural persons)?
                  </b-form-radio>
                  <b-form-radio name="shareholders" v-model="business.shareholders" value="Held by other Business(es) and/or in combination with individual(s) (natural persons)">
                    Held by other Business(es) and/or in combination with individual(s) (natural persons)?
                  </b-form-radio>
                </b-form-group>
              </b-col>
              <b-col md="12" class="mb-3" v-if="business.shareholders === 'Limited to individuals (natural persons)'">
                <b-form-group>
                  <template v-slot:label>
                    Do the Shareholder(s) <strong>(of 5% or more)</strong> and ALL the Director(s) have a South African Identity Document?
                  </template>
                  <b-form-radio name="nationality" v-model="business.nationality" value="Yes">
                    Yes
                  </b-form-radio>
                  <b-form-radio name="nationality" v-model="business.nationality" value="No">
                    No
                  </b-form-radio>
                </b-form-group>
              </b-col>
              <b-col md="12" class="mb-3" v-if="business.nationality === 'Yes'">
                <b-form-group>
                  <template v-slot:label>
                    Does the Business have <strong>more</strong> than 10 (ten) Directors?
                  </template>
                  <b-form-radio name="directors" v-model="business.directors" value="Yes">
                    Yes
                  </b-form-radio>
                  <b-form-radio name="directors" v-model="business.directors" value="No">
                    No
                  </b-form-radio>
                </b-form-group>
              </b-col>
            </div>
            <b-col md="4" offset-md="8" align-self="end">
              <b-button class="mb-3" variant="custom" pill block :disabled="!canGoNext" @click="next()">Next</b-button>
            </b-col>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <!-- Modal -->
    <b-modal id="info_popup" centered hide-header hide-footer>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('info_popup')">×</button>
      <div class="pt-3 px-md-3 pb-md-3">
        <p class="color-navy-blue">Just a quick heads up...</p>
        <p v-if="business.type === 'Listed Company (on recognised stock exchange)'">We're going to need a copy of your <strong>Official Incoporation Documents</strong> AND <strong>Proof of Listing on the Stock Exchange</strong> during registration</p>
        <p v-else-if="business.type === 'Foreign / External Company (Non-SA registered)'">We're going to need a copy of your <strong>Official Incorporation Documents</strong> during registration</p>
        <p v-else-if="business.type === 'Trust'">We're going to need a copy of your <strong>Trust Deed</strong> AND <strong>Letter of Authority</strong> during registration</p>
        <p v-else-if="business.type === 'Partnership'">We're going to need a copy of your <strong>Partnership Agreement</strong> during registration</p>
        <p v-else-if="business.type === 'Charity / Foundation / Non-Profit Organisation'">We're going to need a copy of your <strong>Constitution / Official Incorporation Documents</strong> during registration</p>
        <p v-else-if="business.type === 'SA Registered Company (Private Company – Pty Limited)'">We're going to need a copy of your <strong>CIPC CoR 15.1 (Memorandum of Incorporation)</strong> and <strong>Ultimate Beneficial Owners and Shareholder Structure</strong> during registration</p>
        <p v-else-if="business.type === 'SA Registered Closed Corporation (CC)'">We're going to need a copy of your <strong>CIPC CoR 15.1 (Memorandum of Incorporation)</strong> and <strong>Ultimate Beneficial Owners and Shareholder Structure</strong> during registration</p>
        <b-row align-h="center">
          <b-col md="6">
            <b-button class="mt-2" type="button" variant="outline-custom" pill block @click="takeBack()">Ugh. I'll be back</b-button>
          </b-col>
          <b-col md="6">
            <b-button class="mt-2" type="button" variant="custom" pill block @click="$bvModal.hide('info_popup')">I'm good to go!</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="status_popup" centered hide-header hide-footer>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('status_popup')">×</button>
      <div class="pt-3 px-md-3 pb-md-3">
        <p>Unfortunately we cannot continue with the registration process at this time as we are unable to successfully verify a de-registered business. Please select a different Business Status or alternatively, you may register as an individual.</p>
        <b-row align-h="center">
          <b-col md="6">
            <b-button class="mt-2" type="button" variant="outline-custom" pill block @click="takeBack()">Ugh. I'll be back</b-button>
          </b-col>
          <b-col md="6">
            <b-button class="mt-2" type="button" variant="custom" pill block @click="$bvModal.hide('status_popup')">Select another!</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="solprop_popup" centered hide-header hide-footer>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('solprop_popup')">×</button>
      <div class="pt-3 px-md-3 pb-md-3">
        <p>Registering as a Sole Proprietor is the same as registering as an individual user. Since you're already registered as an individual, there's no need to register another profile.</p>
        <b-row align-h="center">
          <b-col md="6">
            <b-button class="mt-2" type="button" variant="custom" pill block @click="() => {
              $bvModal.hide('solprop_popup')
              $bvModal.hide('business-new')
            }">Continue!</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <!-- END | Modal -->
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      business: {
        status: null,
        type: null,
        shareholders: null,
        nationality: null,
        directors: null
      },
      payment: {
        card: {
          number: null,
          expMonth: null,
          expYear: null,
          expiration: null,
          cvc: null
        },
        name: null,
        save_details: true,
        processing: false,
        processed: null,
        error: null,
        secure: null,
        orderid: null,
        have_coupon: true,
        coupon: 'FREEREGISTRATION'
      }
    }
  },
  computed: {
    ...mapState({
      businessStore: state => state.business,
      registration: state => state.registration
    }),
    statuses () {
      const _statuses = []
      this.businessStore.Statuses.forEach(_status => {
        _statuses.push({ value: _status, label: _status })
      })

      return _statuses
    },
    types () {
      const _types = []
      this.businessStore.Types.forEach(_type => {
        _types.push({ value: _type, label: _type })
      })

      return _types
    },
    canGoNext () {
      if (this.business.status && this.business.status !== 'De-Registered' && this.business.type && this.business.type !== 'Sole Proprietor') {
        if (this.business.type === 'SA Registered Company (Private Company – Pty Limited)' || this.business.type === 'SA Registered Closed Corporation (CC)') {
          if (this.business.shareholders === 'Held by other Business(es) and/or in combination with individual(s) (natural persons)') {
            return true
          } else if (this.business.nationality === 'No') {
            return true
          } else if (this.business.directors) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  mounted () {
    this.business = this.registration.business
    this.payment = this.registration.payment
    this.$mixpanel.track('Business Registration')
  },
  methods: {
    ...mapActions('alert', {
      setSuccess: 'success',
      setError: 'error',
      clear: 'clear'
    }),
    ...mapActions('registration', {
      update: 'updateState'
    }),
    next: function () {
      if (this.canGoNext) {
        if (this.payment.have_coupon && this.payment.coupon) {
          this.payment.processing = false
          this.payment.processed = true
          this.payment.orderid = 'COUPON: ' + this.payment.coupon
        } else {
          this.payment = {
            card: {
              number: null,
              expMonth: null,
              expYear: null,
              expiration: null,
              cvc: null
            },
            name: null,
            save_details: true,
            processing: false,
            processed: null,
            error: null,
            secure: null,
            orderid: null,
            have_coupon: false,
            coupon: null
          }
        }

        this.update({
          state: 'business',
          value: this.business
        })
        this.update({
          state: 'payment',
          value: this.payment
        })
        this.$bvModal.hide('business-new')
        this.$bvModal.show('business-details-new')
      } else {
        this.clear()
        this.setError('You have to complete all the fields here before moving to the next section.')
      }
    },
    takeBack: function () {
      this.business.status = null
      this.business.type = null
      this.$bvModal.hide('status_popup')
      this.$bvModal.hide('info_popup')
      this.$bvModal.hide('business-new')
    },
    goIndividual: function () {
      this.update({
        state: 'registration_type',
        value: 'Individual'
      })

      this.$router.push('/register/individual')
    }
  },
  watch: {
    'business.status': function (value) {
      if (value === 'De-Registered') {
        this.$bvModal.show('status_popup')
        this.business.status = null
      }
    },
    'business.type': function (value) {
      if (value === 'Listed Company (on recognised stock exchange)' || value === 'Foreign / External Company (Non-SA registered)' || value === 'Trust' || value === 'Partnership' || value === 'Charity / Foundation / Non-Profit Organisation') {
        this.$bvModal.show('info_popup')
      }

      if (value === 'Sole Proprietor') {
        this.business.status = null
        this.business.type = null
        this.$bvModal.show('solprop_popup')
      }

      this.business.shareholders = null
      this.business.nationality = null
      this.business.directors = null
    },
    'business.shareholders': function (value) {
      if (value === 'Held by other Business(es) and/or in combination with individual(s) (natural persons)') {
        this.$bvModal.show('info_popup')
      }
    },
    'business.nationality': function (value) {
      if (value === 'No') {
        this.$bvModal.show('info_popup')
      }
    },
    'business.directors': function (value) {
      if (value === 'Yes') {
        this.$bvModal.show('info_popup')
      }
    }
  }
}
</script>
